import axios from 'axios';
import mongoose from 'mongoose'; // mongooseをインポート

export interface DisasterEvent {
  _id?: string; // MongoDB の _id
  id: string;
  title: string;
  description: string;
  lat: number;
  lon: number;
  eventType: string;
  alertLevel: string;
  country?: string;
  eventname?: string;
  severity?: string;
  mediaItems: mongoose.Types.ObjectId[]; // MediaItemへの参照を配列で持つ
}

const GDACS_DB_URL = '/api/disasterEvents/db'; // 新しいエンドポイント

export async function fetchDisasterData(): Promise<DisasterEvent[]> {
  try {
    const response = await axios.get(GDACS_DB_URL); // 新しいエンドポイントを使用
    const events = response.data.map((item: DisasterEvent) => ({
      _id: item._id, // MongoDB の _id
      id: item.id,
      title: item.title,
      description: item.description,
      lat: item.lat,
      lon: item.lon,
      eventType: item.eventType,
      alertLevel: item.alertLevel,
      country: item.country,
      eventname: item.eventname,
      severity: item.severity,
      mediaItems: item.mediaItems,
    }));
    return events;
  } catch (error) {
    console.error('Error fetching disaster data:', error);
    throw error;
  }
}
